<template>
  <v-list dense>
    <v-list-item v-if="scenarioBuilder.plays.length === 0" dense disabled>
      <v-icon small class="mr-2" color="grey" v-text="mdiSquareMedium" />
      <v-list-item-content>
        <v-list-item-title class="font-weight-regular">
          No plays selected
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>
    <v-list-item v-else v-for="(play, index) in scenarioBuilder.plays" :key="index" dense>
      <v-icon small class="mr-2" v-text="mdiSquareMedium" />
      <v-list-item-content>
        <v-row no-gutters class="d-flex">
          <p class="font-weight-light mb-0">
            {{ play.id }}
          </p>
          <v-spacer></v-spacer>
          <div class="d-inline-block">
            <v-btn
              icon
              x-small
              @click="updateScenarioBuilder(['reorder', { newIndex: index - 1, oldIndex: index }])"
              :disabled="index === 0"
              title="Move Play Up">
              <v-icon small color="warning" v-text="mdiChevronUp" />
            </v-btn>
            <v-btn
              icon
              x-small
              @click="updateScenarioBuilder(['reorder', { newIndex: index + 1, oldIndex: index }])"
              :disabled="index === scenarioBuilder.plays.length - 1"
              title="Move Play Down">
              <v-icon small color="warning" v-text="mdiChevronDown" />
            </v-btn>
            <v-btn
              icon
              x-small
              @click="updateScenarioBuilder(['remove', play.id])"
              class="ml-2"
              title="Remove Play">
              <v-icon small color="error" v-text="mdiCloseCircleOutline" />
            </v-btn>
          </div>
        </v-row>
      </v-list-item-content>
    </v-list-item>
  </v-list>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import {
  mdiSquareMedium,
  mdiChevronUp,
  mdiChevronDown,
  mdiCloseCircleOutline
} from '@mdi/js';

export default {
  name: 'scenarioList',
  data() {
    return {
      mdiSquareMedium,
      mdiChevronUp,
      mdiChevronDown,
      mdiCloseCircleOutline
    };
  },
  computed: {
    ...mapGetters([
      'scenarioBuilder'
    ])
  },
  methods: {
    ...mapActions([
      'updateScenarioBuilder'
    ])
  }
};
</script>
